<script>
import Layout from "@/router/layouts/auth";
import { api } from "@/state/services";
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import Password from "@/components/widgets/input-password";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Password
  },
  data() {
    return {
      recover: {
        loading: false,
        personNumberMask: "###.###.###-##",
        personNumber: "",
      },

      validate: {
        loading: false,
        code: "",
      },

      change: {
        loading: false,
        newest: "",
        confirm: "",
      },

      step: 1,
    };
  },
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  validations: {
    recover: {
      personNumber: { required },
    },
    validate: {
      code: { required },
    },
    change: {
      newest: { required },
      confirm: { required },
    },
  },
  methods: {
    recoverSubmit() {
      this.$v.recover.$touch();
      if (this.$v.recover.$invalid) {
        return;
      } else {
        this.recover.loading = true

        if (this.recover.personNumber) {
          api
            .post('password/recover', {
              personNumber: this.recover.personNumber,
            })
            .then(response => {
              if (response.data.status == 'success') {
                this.$toast.success(response.data.message)
                this.recover.personNumber = ''
                this.$v.recover.$reset()

                this.step = 2;
              } else {
                this.$toast.error(response.data.message)
              }

              this.recover.loading = false
            })
        }
      }
    },
    validateCode() {
      this.$v.validate.$touch();
      if (this.$v.validate.$invalid) {
        return;
      } else {
        this.validate.loading = true

        if (this.validate.code) {
          api
            .post('password/validate', {
              code: this.validate.code,
            })
            .then(response => {
              if (response.data.status == 'success') {
                this.step = 3;
              } else {
                this.$toast.error(response.data.message)
              }

              this.validate.loading = false
            })
        }
      }
    },
    changePassword() {
      this.$v.change.$touch();
      if (this.$v.change.$invalid) {
        return;
      } else {
        this.change.loading = true;

        if (this.change.newest && this.change.confirm) {
          api
            .post("password/change", {
              code: this.validate.code,
              new: this.change.newest,
              confirm: this.change.confirm,
            })
            .then((response) => {
              if (response.data.status == 'success') {
                this.validate.code = "";
                this.change.newest = "";
                this.change.confirm = "";
                this.$v.change.$reset();

                this.$toast.success(response.data.message);

                this.step = 4;
              } else {
                this.$toast.error(response.data.message);
              }

              this.change.loading = false;
            });
        }
      }
    },
  },
  watch: {
    'recover.personNumber'(value) {
      if (value.length <= 14) {
        this.recover.personNumberMask = '###.###.###-##';
      } else {
        this.recover.personNumberMask = '##.###.###/####-##';
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 pb-2 text-center">
          <router-link class="align-middle" tag="a" to="/">
            <img class="w-100" style="max-width: 250px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <template v-if="step == 1">
            <h5 class="mb-4">Esqueceu sua senha?</h5>
            <b-form @submit.prevent="recoverSubmit">
              <b-form-group id="personNumber" label="CPF/CNPJ" label-for="recover.personNumber">
                <b-form-input id="personNumber" v-model="recover.personNumber" type="text" :class="{ 'is-invalid': $v.recover.personNumber.$error }" v-mask="recover.personNumberMask"
                  :key="'recover.step'"></b-form-input>
                <div v-if="$v.recover.personNumber.$error" class="invalid-feedback">
                  <span v-if="!$v.recover.personNumber.required">O CPF/CNPJ é obrigatório.</span>
                </div>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="recover.loading == true" type="submit" variant="default" class="btn-lg btn-block">
                  Recuperar
                  <b-spinner v-if="recover.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </template>
          <template v-else-if="step == 2">
            <h5 class="mb-4">Informe o código de validação</h5>
            <b-form @submit.prevent="validateCode">
              <b-form-group id="validate.code" label="Código" label-for="validate.code">
                <b-form-input id="validate.code" v-model="validate.code" type="text" :class="{ 'is-invalid': $v.recover.personNumber.$error }" v-mask="'# # # # # #'"
                  :key="'validate.code'"></b-form-input>
                <div v-if="$v.validate.code.$error" class="invalid-feedback">
                  <span v-if="!$v.validate.code.required">O código de validação é obrigatório.</span>
                </div>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="validate.loading == true" type="submit" variant="default" class="btn-lg btn-block">
                  Validar
                  <b-spinner v-if="validate.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </template>
          <template v-else-if="step == 3">
            <h5 class="mb-4">Redefina sua senha</h5>
            <b-form @submit.prevent="changePassword">
              <b-form-group id="change.newest" label="Nova senha" label-for="change.newest" :key="'change.newest'">
                <Password v-model="change.newest" :v="$v.change.newest"></Password>
              </b-form-group>
              <b-form-group id="change.confirm" label="Confirmar senha" label-for="change.confirm" :key="'change.confirm'">
                <Password v-model="change.confirm" :v="$v.change.confirm"></Password>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="change.loading == true" type="submit" variant="default" class="btn-lg btn-block">
                  Alterar
                  <b-spinner v-if="change.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </template>
          <template v-if="step == 4">
            <div class="text-center">
              Sua senha foi alterada com sucesso.
            </div>
          </template>
          <div class="text-center py-5">
            <router-link tag="a" to="/login" class="d-block btn btn-outline-default btn-lg btn-block mt-2">Entrar</router-link>
          </div>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block"></div>
    </div>
  </Layout>
</template>
